
        // Import from the new modular structure
        import { GameInitializer, setupMenuNavigation, loadTrackByName } from './js/GameInitializer.js';
        import { getAvailableTracks } from './js/Utils.js';

        // Global game initializer instance
        let gameInitializer;

        // Make functions globally available for module system
        window.loadTrackByName = loadTrackByName;

        window.togglePauseGame = () => {
            if (window.gameStateManager) {
                window.gameStateManager.togglePause();
            }
        };

        window.cleanupGame = () => {
            if (gameInitializer) {
                gameInitializer.cleanup();
            }
        };

        document.addEventListener('DOMContentLoaded', async function () {
            // Initialize game system
            gameInitializer = new GameInitializer();

            // Show main menu by default
            document.getElementById('main-menu').style.display = 'block';

            // Setup menu navigation with game initializer
            setupMenuNavigation(gameInitializer);

            // Populate track selection dropdowns
            populateTrackSelect('trackSelect-network');
            populateTrackSelect('trackSelect-single');
        });

        // Handle audio context initialization on first user interaction
        function initializeAudioContext() {
            if (window.AudioContext || window.webkitAudioContext) {
                const audioContext = new (window.AudioContext || window.webkitAudioContext)();
                if (audioContext.state === 'suspended') {
                    audioContext.resume().then(() => {
                        console.log('Audio context resumed successfully');
                    }).catch(err => {
                        console.warn('Failed to resume audio context:', err);
                    });
                }
            }
        }

        // Add audio context initialization to all user interactions
        document.addEventListener('click', initializeAudioContext, { once: true });
        document.addEventListener('touchstart', initializeAudioContext, { once: true });

            // Initialize touch controls if on a touch device
            if ('ontouchstart' in window) {
                document.getElementById('touch-controls').style.display = 'block';
            }
        // Initialize touch controls if on a touch device
        if ('ontouchstart' in window) {
            document.getElementById('touch-controls').style.display = 'block';
        }

        // Populate track selection dropdowns
        function populateTrackSelect(selectId) {
            const select = document.getElementById(selectId);
            if (!select) return;

            // Clear existing options
            select.innerHTML = '';

            // Get available tracks
            const tracks = getAvailableTracks();

            // Add each track as an option
            tracks.forEach(track => {
                const option = document.createElement('option');
                option.value = track.name;
                option.textContent = track.displayName;
                select.appendChild(option);
            });
        }
    